import type { FC } from 'react'

import { TECH_STACK } from '@/constants/kinematic'

const TechMarquee: FC = () => {
    const items = [...TECH_STACK, ...TECH_STACK]

    return (
        <section aria-label='What the games run on' className='relative overflow-hidden border-y border-white/[0.06] bg-ink py-5'>
            <ul className='flex w-max animate-marquee items-center hover:[animation-play-state:paused] motion-reduce:animate-none'>
                {items.map((item, index) => (
                    <li
                        key={`${item}-${index}`}
                        aria-hidden={index >= TECH_STACK.length}
                        className='flex shrink-0 items-center gap-10 pr-10 font-mono text-[11px] uppercase tracking-[0.18em] text-steel'
                    >
                        <span className='whitespace-nowrap'>{item}</span>
                        <span aria-hidden='true' className='size-1.5 rotate-45 bg-ember/70' />
                    </li>
                ))}
            </ul>

            <div aria-hidden='true' className='pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent' />
            <div aria-hidden='true' className='pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent' />
        </section>
    )
}

export default TechMarquee
